export default __webpack_public_path__ + "static/media/AvenirNextW04-Regular.f8a97592.woff2";